import React from "react";
import {
  Button,
  Grid,
  Paper,
  Select,
  Typography,
  MenuItem,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useTranslation } from "react-i18next";
import { isNotNullOrEmptyArray } from "../../globals/utils";

const ProcurementPickupForm = ({
  formData,
  errors,
  onChange,
  onSubmit,
  biocharPlants,
}) => {
  const { t } = useTranslation();

  return (
    <Paper
      sx={{
        padding: 3,
        maxWidth: 600,
        margin: "auto",
        paddingBottom: 10,
        mt: 2,
        mr: 2,
        ml: 2,
      }}
    >
      <Typography variant="h5" gutterBottom>
        {t("Request Pickup")}
      </Typography>
      <form onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DateTimePicker"]}>
                <DateTimePicker
                  label={t("Pickup Requested On")}
                  name="pickup_requested_on"
                  value={formData.pickup_requested_on}
                  onChange={(value) =>
                    onChange({
                      target: { name: "pickup_requested_on", value: value },
                    })
                  }
                  error={!!errors.pickup_requested_on}
                  helperText={errors.pickup_requested_on}
                  required
                  fullWidth
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
          {isNotNullOrEmptyArray(biocharPlants) && (
            <Grid item xs={12}>
              <Select
                fullWidth
                label={t("Inward Plant")}
                name="pickup_plant"
                value={formData.pickup_plant}
                onChange={onChange}
                required
                error={!!errors.pickup_plant}
                helperText={errors.pickup_plant}
              >
                {biocharPlants.map((plant) => (
                  <MenuItem key={plant.id} value={plant.id}>
                    {plant.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          )}
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              {t("Submit")}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default ProcurementPickupForm;
